export default __webpack_public_path__ + "static/media/kiara4.b5e3d050.jpg";